import { FC } from 'react';
import liveActs from './../../../../assets/images/no-live-acts.png';
import { useTranslation } from 'react-i18next';

export const NoActivity: FC = () => {
	const { t } = useTranslation();
	return (
		<div className="text__default no__live_activity flex h-full w-full items-center justify-center bg-gradient-to-r from-green-400 to-blue-500">
			<div className="flex flex-col items-center justify-center">
				<img src={liveActs} alt="no-live" />
				<span className=" text-white">{t('noActivity')}</span>
			</div>
		</div>
	);
};
